export enum PaymentType {
    BarionCard,
    RevolutCard,
    PayOnDeliveryCard,
    PayOnDeliveryCash,
    ApplePay,
    GooglePay,
}
